<template lang="pug">
v-expansion-panel(:class="active ? '' : 'accordion'")
  v-expansion-panel-content(class="slim-header")
    template(v-slot:actions)
      div(v-if="merchantId" class='header-btn-area')
        p(style="text-align: right;")
          | <strong>Merchant ID</strong> {{ merchantId }}
        AppOutlinedButton(:buttonFunction="openPlansModal") MANAGE
    //- this is the part visible by default. it includes the logo, subtitle
    LenderListTile(
      slot="header"
      :logoSvg="logoSvg"
      :title="typeLabel"
      :subtitle="name"
      :merchantId="merchantId"
      :active="active"
      :readMoreLink="readMoreLink"
      :color="color"
      :enrollmentLink="enrollmentLink"
    )
    template(v-if="!active && merchantId")
      p.pa-4 Your Merchant ID: {{ merchantId }} has been deactivated, please contact us using the Intercom Button or call us at (786) 375-9482

    template(v-else-if="active")
      PlansSelectionModal(
        :isModalActive="isModalActive"
        :lenderName="nickName"
        :plans="gsPlans"
        :additionalInfo="additionalInfo"
        @close="closePlansModal"
        @save="savePlans"
      )

    v-card(v-else) 
      v-card-text
        template(
          v-for="bit in description"
        )
          p(
            v-if="typeof bit === 'string'"
            v-html="bit"
            :key="bit"
            style="text-align:left"
            class="grey--text text--darken-3"
          )
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import { greensky } from '@/helpers/lenders.js'
import LenderListTile from '@/components/LenderListTile'
import AppOutlinedButton from 'Components/AppOutlinedButton.vue'
import PlansSelectionModal from 'Components/PlansSelectionModal.vue'
const { logoSvg, typeLabel, name, nickName, color, enrollmentLink, readMoreLink, description, additionalInfo } = greensky

export default {
  name: 'greensky-plan-expander',
  components: {
    LenderListTile,
    AppOutlinedButton,
    PlansSelectionModal
  },
  props: {
    merchantId: String,
    active: {
      type: Boolean,
      default: null
    },
  },
  data() {
    return {
      lenderId: "greensky",
      logoSvg,
      name,
      nickName,
      typeLabel,
      description,
      color,
      enrollmentLink,
      readMoreLink,
      additionalInfo,
      isModalActive: false,
    }
  },
  methods: {
    ...mapActions([
      'setActiveStateGSPlans'
    ]),
    openPlansModal() {
      this.isModalActive = true
    },
    closePlansModal() {
      this.isModalActive = false
    },
    savePlans(selectedPlansMap, savedPlansMap) {
      // Here, we get the set difference (A-B) of the selected plans
      // and the saved plans so that we only change what needs to be.
      // After doing that, we map it to fit the data request for the
      // set active endpoint
      const planIdActiveStates = Object.entries(selectedPlansMap)
        .filter(plan => Object.entries(savedPlansMap).some(p => p[0] === plan[0] && p[1] != plan[1]))
        .map((plan) => ({ planId: plan[0], isActive: plan[1] }));

      this.setActiveStateGSPlans(planIdActiveStates)
    }
  },
  computed: {
    ...mapState({
      dealerId: state => state.user.dealerId
    }),
    ...mapGetters({
      gsPlans: 'greenskyPlans',
    }),
  },
}
</script>

<style scoped lang="scss">
.accordion::v-deep .v-expansion-panel__header__icon {
  display: none !important;
}

.slim-header>>>.expansion-panel__header {
  padding: 0;

  & .header__icon {
    margin-right: 10px;
  }
}

.header-btn-area {
  height: 100%;
  min-height: 150px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-end;
}

</style>